/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/PhoneIphone';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const PhoneIphoneIcon = withMuiAdapter(Base, 'PhoneIphone');
